document.addEventListener("turbolinks:load", function () {
    // Set up language modal using functionality from vb_modal.js
    if (document.querySelector(".language-modal__button")) {
        setUpModal(".language-modal__button", ".language-modal");
    }
})